<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.bankdetails')"
        :col="3"
      >
        <button
          class="btn btn-primary"
          @click="showBankverbindungHinzufuegen"
          v-if="editable"
        >
          <font-awesome-icon icon="fa-regular fa-plus" />{{ $t("global.addbankdetails") }}
        </button>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block br-t-l-0">
          <div :key="bankverbindungenkey" class="list-group">
            <div class="row px-3 py-2 text-bold" v-if="bankverbindungen.length > 0">
              <div class="col-xl-2">{{ $t("global.edit") }}</div>
              <div class="col-xl-2">{{ $t("global.bankdetails") }}</div>
              <div class="col-xl-2">{{ $t("global.account") }}</div>
              <div class="col-xl-2">{{ $t("global.iban") }}</div>
              <div class="col-xl-2">{{ $t("global.bcnumber") }}</div>
            </div>
            <bankverbindung
              v-for="(bv, indexBV) in bankverbindungen"
              :key="bv.id || bv.key"
              :bankverbindung="bv"
              :index="indexBV"
              :editable="editable"
              @deleteBankverbindung="bankverbindungDeleted"
              @bankverbindungAendern="showBankverbindungAendern"
            ></bankverbindung>
            <div
              class="text-center text-primary my-2"
              v-if="bankverbindungen.length == 0"
            >
              <strong>{{ $t("global.nobankdetailsavailable") }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bankverbindung-modal
      method="bankverbindungHinzugfuegt"
      @bankverbindungCreated="bankverbindungHinzufuegen"
      @bankverbindungChanged="bankverbindungAendern"
    ></bankverbindung-modal>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";
import { uuidv4 } from "@/utils/Uuid";

import BankverbindungModal from "@/components/Modals/BankverbindungModal";
import Bankverbindung from "@/components/Geschaeftspartner/Bankverbindung";

export default {
  components: {
    ContainerHeadline,
    BankverbindungModal,
    Bankverbindung,
  },
  props: {
    person: {
      type: String,
      required: true,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    initialBankverbindungen: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      bankverbindungen: [],
      bankverbindungenkey: uuidv4(),
    };
  },
  watch: {
    shown(val) {
      if (val) {
        this.bankverbindungen = [...this.initialBankverbindungen];
      }
    },
    initialBankverbindungen(val) {
      this.bankverbindungen = [...val];
    },
  },
  computed: {},
  created() {
    this.bankverbindungen = [...this.initialBankverbindungen];
  },
  methods: {

    bankverbindungDeleted(indexBV) {
      if (this.bankverbindungen[indexBV].id) {
        this.bankverbindungen[indexBV].delete = true;
        this.updateParent();
      }
    },

    showBankverbindungAendern(indexBV) {
      if (this.bankverbindungen[indexBV]) {
        this.bankverbindungen[indexBV].neueBankverbindung = false;
        this.$bus.$emit(
          "bankverbindung-modal-show",
          this.bankverbindungen[indexBV]
        );
      }
    },

    bankverbindungAendern(updateBankverbindung) {
      let pos = this.bankverbindungen.findIndex(
        (bv) => bv.id === updateBankverbindung.id
      );

      if (pos != -1) {
        this.bankverbindungen[pos] = updateBankverbindung;
        this.bankverbindungenkey = uuidv4();
        this.updateParent();
      }
    },

    showBankverbindungHinzufuegen() {
      this.$bus.$emit("bankverbindung-modal-show", {
        neueBankverbindung: true,
      });
    },

    bankverbindungHinzufuegen(bankverbindung) {
      this.bankverbindungenkey = uuidv4();
      this.bankverbindungen.push(bankverbindung);
      this.updateParent();
    },

    updateParent() {
      this.$emit("updatebankverbindung", {
        bankverbindungen: this.bankverbindungen,
      });
    },
  },
};
</script>
